import Logger from '../logger';
import event from '../mixins/event';

class ActionArea {

	// Vars
	// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

	/**
	 * Class constructor
	 */
	constructor(dom) {

		this.NAME = 'ActionArea';

		this.dom = dom;

		this.pillDoms = this.dom.querySelectorAll(`[data-product-message-pill]`);

	}

	/**
	 * init - Initialize the form
	 */
	init() {
		Logger.info(`${this.NAME} > init`);

		const self = this;

		// Listen for on:price:update event on document
		document.addEventListener('on:price:update', function (e) {
			self.onPriceUpdate(e);
		});

		// Listen for on:availability:update event on document
		document.addEventListener('on:availability:update', function (e) {
			self.onAvailabilityUpdate(e);
		});

	}

	onAvailabilityUpdate(e) {
		Logger.info(`${this.NAME} > onAvailabilityUpdate`);

		const payload = e.detail;

		this.pillDoms.forEach((pillDom) => {
			const pillType = pillDom.dataset.productMessagePill;

			if (!pillType) return;

			if (pillType === 'in-stock') {
				if (payload.variant && !payload.variant.available)
					pillDom.classList.remove('product-message-pill--active');
				else
					pillDom.classList.add('product-message-pill--active');
			}
		});
	}

	/**
	 * onPriceUpdate - Handle the on:price:update event
	 */
	onPriceUpdate(e) {
		Logger.info(`${this.NAME} > onPriceUpdate`);

		const payload = e.detail;

		this.pillDoms.forEach((pillDom) => {
			const pillType = pillDom.dataset.productMessagePill;

			if (!pillType) return;

			if (pillType === 'on-sale') {
				if (payload.variant && payload.variant.compare_at_price > payload.variant.price)
					pillDom.classList.add('product-message-pill--active');
				else
					pillDom.classList.remove('product-message-pill--active');
			}
		});

		this.price = this.price || this.dom.querySelector('.product-info__price > .price');
		if (!this.price) return;

		if (payload.variant) {

			const priceCurrentEl = this.price.querySelector('.price__current');
			const priceWasEl = this.price.querySelector('.price__was');
			const unitPriceEl = this.price.querySelector('.unit-price');

			// Update current price and original price if on sale.
			priceCurrentEl.innerHTML = payload.price;
			if (priceWasEl)
				priceWasEl.innerHTML = payload.compareAtPrice || '';

			// Update unit price, if specified.
			if (payload.variant.unit_price_measurement) {
				const valueEl = this.price.querySelector('.unit-price__price');
				const unitEl = this.price.querySelector('.unit-price__unit');
				const value = payload.variant.unit_price_measurement.reference_value;
				const unit = payload.variant.unit_price_measurement.reference_unit;

				const formattedPrice = Intl.NumberFormat("en-EN", { trailingZeroDisplay: "stripIfInteger" }).format(payload.unitPrice);
				valueEl.innerHTML = formattedPrice;
				unitEl.textContent = value === 1 ? unit : `${value} ${unit}`;
			}

			unitPriceEl.hidden = !payload.variant.unit_price_measurement;
			this.price.classList.toggle(
				'price--on-sale',
				payload.variant.compare_at_price > payload.variant.price
			);
			this.price.classList.toggle('price--sold-out', !payload.variant.available);
		}

		this.price.querySelector('.price__default').hidden = !payload.variant;
		this.price.querySelector('.price__no-variant').hidden = payload.variant;
	}

}

Object.assign(ActionArea.prototype, event);

export default ActionArea;
